// A conversa fica no sessionStorage da aba: sobrevive ao recarregar e some ao fechar a aba.
// O secureStorage só grava no localStorage, que sobreviveria ao fechar o navegador.
export const CHAVE_CONVERSA = "chatbotSuporte:conversa";

export function salvarConversa({ idEmpresa, idUsuario, conversa, texto }) {
  try {
    sessionStorage.setItem(CHAVE_CONVERSA, JSON.stringify({ idEmpresa, idUsuario, conversa, texto }));
  } catch (erro) {
    // Storage indisponível ou cheio: a conversa continua só em memória.
  }
}

export function limparConversa() {
  try {
    sessionStorage.removeItem(CHAVE_CONVERSA);
  } catch (erro) {
    // Storage indisponível: não há o que limpar.
  }
}

// Devolve a conversa salva pela mesma empresa e usuário, ou null.
export function lerConversa(idEmpresa, idUsuario) {
  let salva;
  try {
    salva = JSON.parse(sessionStorage.getItem(CHAVE_CONVERSA));
  } catch (erro) {
    return null;
  }

  if (!salva?.conversa?.iniciada || salva.idEmpresa !== idEmpresa || salva.idUsuario !== idUsuario) {
    return null;
  }

  const { conversa, texto } = salva;
  const pesquisa = { ...conversa.pesquisa, enviando: false };

  // A resposta da pergunta pendente se perdeu no recarregamento: ela volta ao campo, como numa falha.
  if (conversa.loading) {
    const pergunta = conversa.messages[conversa.messages.length - 1];
    return {
      conversa: {
        ...conversa,
        messages: conversa.messages.slice(0, -1),
        loading: false,
        error: "errors.answer",
        pesquisa,
      },
      texto: pergunta?.content ?? texto,
    };
  }

  return { conversa: { ...conversa, pesquisa }, texto: texto ?? "" };
}
